// extracted by mini-css-extract-plugin
module.exports =  {"icon":"Cd0ol8hBFVkKcTmwqG4Y","select":"VpFCvXTLQeUCwuqmenLw"};